import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from "@angular/router";
import { LaboratorioService } from '../../services/laboratorio.service';

@Component({
    selector: 'app-laboratorio',
    templateUrl: './laboratorio.component.html',
    styleUrls: ['./laboratorio.component.css'],
    standalone: false
})
export class LaboratorioComponent implements OnInit {
  total = 11;
  loading = true;
  search; //String que irá guardar o que o usuário quer pesquisar
  isVisibleCancelFiltro = false;
  pageSize = 10;
  pageIndex = 1;
  isVisibleDetalhe = false;
  laboratorios = [];

  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private laboratorioService: LaboratorioService,
  ) { }

  ngOnInit(): void {
  }


  ativar(idlaboratorio) {
    let idLoading = this.message.loading('Ativando laboratório...').messageId;
    this.laboratorioService.ativar(idlaboratorio).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Ativação realizada com SUCESSO!');
      this.loading = true;
      this.laboratorioService.all(this.pageIndex).subscribe((m: any) => {
        this.laboratorios = m.data.laboratorio.data;
        this.total = m.data.laboratorio.total;
        this.pageSize = m.data.laboratorio.per_page;
        this.loading = false;
      });
    });
  }

  inativar(idlaboratorio) {
    let idLoading = this.message.loading('Inativando laboratório...').messageId;
    this.laboratorioService.inativar(idlaboratorio).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Inativação realizada com SUCESSO!');
      this.loading = true;
      this.laboratorioService.all(this.pageIndex).subscribe((m: any) => {
        this.laboratorios = m.data.laboratorio.data;
        this.total = m.data.laboratorio.total;
        this.pageSize = m.data.laboratorio.per_page;
        this.loading = false;
      });
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.laboratorioService.all(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.laboratorios = m.data.laboratorio.data;
      this.total = m.data.laboratorio.total;
      this.pageSize = m.data.laboratorio.per_page;
      this.loading = false;
    });
  }

  removerFiltro() {
    this.search = '';
    this.searchLaboratorio();
    this.isVisibleCancelFiltro = false;
  }


  searchLaboratorio() {
    if (this.search !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true; 
 
      this.laboratorioService.all(this.pageIndex, this.search).subscribe((m: any) => {
        this.pageIndex = 1;
        this.laboratorios = m.data.laboratorio.data;
        this.total = m.data.laboratorio.total;
        this.pageSize = m.data.laboratorio.per_page;
        this.loading = false;
      });
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }
}
